import React from "react";
import { NavLink } from "react-router-dom";
import { toast, } from 'react-toastify'
import withStyles from "@material-ui/core/styles/withStyles";
import Contacts from "@material-ui/icons/Contacts";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import { fetchData } from '../../utils/handleApi'
class ProductForm extends React.Component {
  state = {
      name: "",
      nameState: "",
      productId: "",
      productIdState: "",
      
      required: "",
      requiredState: "",
      typeEmail: "",
      typeEmailState: "",
      number: "",
      numberState: "",
      url: "",
      urlState: "",
      equalTo: "",
      whichEqualTo: "",
      equalToState: "",
      
      minLength: "",
      minLengthState: "",
      maxLength: "",
      maxLengthState: "",
      range: "",
      rangeState: "",
      minValue: "",
      minValueState: "",
      maxValue: "",
      maxValueState: "",
      
      isFormSubmitting : false,
    }
  
  componentDidMount(){
    document.getElementById("productId").min = "0"
    fetchData('product/newId', 'post', {
      type: "A",
      lender_id: this.props.match.params.lenderId
    })
    .then(data => {
      if(data.err){
        return toast.error('Some error happened!')
      }
      const { product_id } = data
      this.setState({
        productId: `${product_id.toString().padStart(4,0)}`,
        productIdState: "success"
      })
    })
  }

  
  verifyEmail(value) {
    let emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }
  
  verifyNumber(value) {
    let numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }
  
  verifyUrl(value) {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  }

  change(event, stateName, type, stateNameEqualTo, maxValue) {
    switch (type) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "password":
        if (this.verifyLength(event.target.value, 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "equalTo":
        if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "checkbox":
        if (event.target.checked) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "number":
        if (this.verifyNumber(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "length":
        if (this.verifyLength((event.target.value).replace(/ /g,""), stateNameEqualTo)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } 
        else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-length":
        if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "url":
        if (this.verifyUrl(event.target.value)) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "min-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "max-value":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value <= stateNameEqualTo
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      case "range":
        if (
          this.verifyNumber(event.target.value) &&
          event.target.value >= stateNameEqualTo &&
          event.target.value <= maxValue
        ) {
          this.setState({ [stateName + "State"]: "success" });
          this.setState({ [stateName]: event.target.value });
        } else {
          this.setState({ [stateName + "State"]: "error" });
        }
        break;
      default:
        break;
    }
    switch (type) {
      case "checkbox":
        this.setState({ [stateName]: event.target.checked });
        break;
      default:
        this.setState({ [stateName]: event.target.value });
        break;
    }
  }

  addProduct = () => {
    const { name, productId } = this.state;
    let isValid = true;

    if (name.trim() === "") {
      this.setState({ nameState: "error" });
      isValid = false;
    }
    if(isValid){
      this.setState({ isFormSubmitting: true })
      const productBody = {
        lender_id: this.props.match.params.lenderId,
        name, product_id:productId, inputs: []
      }
      fetchData('product/add', 'post', productBody)
      .then(data => {
        if(data.err){
          return toast.error('Some error happened!', {
            onClose: () => this.setState({ isFormSubmitting: false })
          })
        }
        toast.success('Product Created Successfully!', {
          onClose: () => this.props.history.goBack()
        })
      })
    }
  }
  
  render() {
    const { productIdState, productId, nameState, isFormSubmitting } = this.state;
    const { classes } = this.props;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader icon>
              <CardIcon color="success">
                <Contacts />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Enter Product Details</h4>
              <NavLink to={`/admin/vendor/${this.props.match.params.vendorId}/lender/${this.props.match.params.lenderId}/products`}>
              <Button
              style={{
                float: 'right',
                backgroundColor: "rgb(4, 171, 35)"
              }}
              >
                Back
              </Button>
            </NavLink>
            </CardHeader>
            <CardBody>
              <form>
                <CustomInput
                  success={productIdState === "success"}
                  error={productIdState === "error"}
                  labelText="Product ID *"
                  id="productId"
                  formControlProps={{
                    fullWidth: true,
                    style: {borderBottom: '1px solid #04ab23'}
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "productId", "length", 1),
                    type: "number",
                    value: productId,
                    readOnly: true,
                    disabled: true
                  }}
                />
                <CustomInput
                  success={nameState === "success"}
                  error={nameState === "error"}
                  labelText="Name *"
                  id="name"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: event =>
                      this.change(event, "name", "length", 1),
                    type: "text"
                  }}
                />
                <div className={classes.center}>
                  <Button 
                    disabled={isFormSubmitting} 
                    style={{backgroundColor: "rgb(4, 171, 35)"}} 
                    onClick={this.addProduct}>
                    Add Product
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(validationFormsStyle)(ProductForm);
